exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".overlay[data-v-4ad8b45e] {\n  height: -webkit-fill-available;\n  top: 0;\n  left: 0;\n  background-color: rgba(0, 0, 0, 0.4);\n  z-index: 3;\n}\n.overlay.grow-layer[data-v-4ad8b45e] {\n    z-index: 7;\n}\n", ""]);

// exports
